import { useState } from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';

import { Button, AlertBox, ModalInfo, SvgIcon } from '@/components';

import styles from './TwoFactorAuthModal.module.sass';

export interface TwoFactorAuthModalProps {
  isOpen: boolean;
  isLoading: boolean;
  errorText?: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onClose: () => void;
}

export const TwoFactorAuthModal = ({
  isOpen,
  isLoading,
  errorText,
  onChange,
  onClose,
  onSubmit,
}: TwoFactorAuthModalProps) => {
  const { t } = useTranslation();
  const [otpValue, setOtpValue] = useState<string[]>([]);

  const otpLength = 6;

  const onInputChange = (value: string[]) => {
    setOtpValue(() => value.filter((item) => item.length));
  };

  return (
    <ModalInfo
      isOpen={isOpen}
      isShowCloseButton={false}
      className={styles.modal}
    >
      <div className={styles.icon}>
        <SvgIcon name="scan-verify" />
      </div>

      <div className={styles.title}>
        {t('translation.two_factor_auth_modal.title')}
      </div>

      <div className={styles.description}>
        {t('translation.two_factor_auth_modal.description')}
      </div>

      {!!errorText && (
        <AlertBox type="danger" className={styles.error}>
          {{
            description: errorText,
          }}
        </AlertBox>
      )}

      <div className={styles.form}>
        <Input.OTP
          length={otpLength}
          size="large"
          className={styles.input}
          onChange={onChange}
          onInput={onInputChange}
          autoFocus
        />
      </div>

      <Button
        size="l"
        disabled={isLoading || otpValue.length !== otpLength}
        isLoading={isLoading}
        className={styles.button}
        onClick={onSubmit}
        fullwidth
      >
        {t('translation.two_factor_auth_modal.submit')}
      </Button>

      <button type="button" className={styles.close} onClick={onClose}>
        <SvgIcon name="close" />
      </button>
    </ModalInfo>
  );
};
